// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-layout-pagination-js": () => import("./../../../src/layout/pagination.js" /* webpackChunkName: "component---src-layout-pagination-js" */),
  "component---src-layout-post-detail-js": () => import("./../../../src/layout/post_detail.js" /* webpackChunkName: "component---src-layout-post-detail-js" */),
  "component---src-layout-tags-js": () => import("./../../../src/layout/tags.js" /* webpackChunkName: "component---src-layout-tags-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-gallery-js": () => import("./../../../src/pages/gallery.js" /* webpackChunkName: "component---src-pages-gallery-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

